import { jsx as _jsx } from "react/jsx-runtime";
import useWallet from "../../hooks/useWallet";
import { useConnectModal } from "../Wallet/WalletModal";
const ConnectButton = ({ children, className, }) => {
    const { providers } = useWallet();
    const filteredProviders = providers.filter(p => !!p.autofillSupportedNetworks);
    const { connect } = useConnectModal();
    return (_jsx("button", { onClick: async () => { await connect(); }, "data-attr": "connect-wallet", type: "button", "aria-label": "Connect wallet", disabled: filteredProviders.length == 0, className: `${className} disabled:opacity-50 disabled:cursor-not-allowed enabled:active:animate-press-down`, children: children }));
};
export default ConnectButton;
